var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVoiceCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.9a1 1 0 01.46-.842l4-2.569a1 1 0 011.54.842v9.479a1 1 0 01-1.481.877l-4-2.197A1 1 0 010 17.613V12.9zM20 12.9a1 1 0 00-.46-.842l-4-2.569a1 1 0 00-1.54.842v9.479a1 1 0 001.481.877l4-2.197a1 1 0 00.519-.877V12.9z",
    fill: "#5096E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5v-3a8 8 0 1116 0v3",
    stroke: "#5096E8",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceCall);
export default __webpack_public_path__ + "static/media/voice-call.553f245ef9700f31d22dd16570632c5d.svg";
export { ForwardRef as ReactComponent };